module.exports = __webpack_public_path__ + "static/media/loader.347c8c93.svg";